import { motion } from 'framer-motion';
import { Outlet, useParams } from 'react-router-dom';

import { PageDetailContent } from '@client/toolkit';

import { AgreementPartiesCard } from '../../../components/agreement-parties-card/agreement-parties-card.component';
import { CompaniesAtAddressCard } from '../dashboard/components/companies-at-address-card.component';

export function BuildingAgreementPartiesRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();

  return (
    <>
      <PageDetailContent align="left">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            opacity: { ease: 'linear', duration: 0.2 },
            y: { ease: 'easeInOut', duration: 0.4 },
          }}
          className="space-y-2"
        >
          <AgreementPartiesCard buildingId={buildingId} />
          <CompaniesAtAddressCard />
        </motion.div>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
